exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".common-table-pagination[data-v-6b1fc056]{margin-top:16px}", ""]);

// exports
